import React from "react";
import {
  Home,
  CalendarEvents,
  AdminCalendar,
  Login,
  LoginAwaitingLink,
  SignUpVerify,
  PasswordVerify,
  Logout,

  BookPage,

  UserProfileHome,
  UserInbox,
  UserDonations,
  UserFamily,
  UserProfileSetPassword,
  //UserAddressUpdate,
  UserMobileVerification,
  UserSessionOTPValidation,
  UserFamilyAddressUpdate,
  UserFamilyCreate,
  UserFamilyUpdate,
  UserFamilyView,
  UserFamilyMissingInfoUpdate,

  UserFamilyMemberCreate,
  UserFamilyMemberUpdate,
  UserFamilyMemberView,


  AddressAdmin,
  AddressAreaCreate,
  AddressAreaUpdate,
  AddressSubAreaUpdate,
  AddressAreaView,

  FamilyAdmin,
  FamilyAddressUpdate,
  FamilyCreate,
  FamilyUpdate,
  FamilyView,
  FamilyActivate,

  FamilyMemberCreate,
  FamilyMemberActivate,
  BulkMoveFamilyMembers,
  FamilyMemberUpdate,
  FamilyMemberView,

  ContactUs,
  PrivacyPolicy,

  GenerateQRCode,

  CategoryAdmin,

  DonationAdmin,
  DonationCreate,
  DonationView,
  GuestDonationCreate,

  ExpensesAdmin,
  ExpenseCreate,
  ExpenseView,
  ExpensesSearch,

  StatementsAdmin,

  ContactAdmin,
  BulkSmsSend,
  BulkSmsDeliveryCheck,
  BulkMobileStatusUpdate,
  DonationFollowUpSmsSend,

} from "../pages/route";

const routesConfig = [
  { path: "/", element: <Home />, breadcrumb: "முகப்பு" },

  { path: "/auth", element: <Login />, breadcrumb: "அங்கிகரித்தல்" },
  { path: "/auth/login", element: <Login />, breadcrumb: "உள் நுழைவு" },
  { path: "/auth/login/awaiting-link", element: <LoginAwaitingLink />, breadcrumb: "உள்நுழைவு இணைப்பிற்காக காத்திருக்கிறது" },
  { path: "/register", element: <Login />, breadcrumb: "பதிவு" },
  { path: "/auth/signup", element: <Login />, breadcrumb: "இணைப்பு சரிபார்ப்பு" },
  { path: "/auth/signup/verify", element: <SignUpVerify />, breadcrumb: "இணைப்பு சரிபார்ப்பு" },
  { path: "/auth/password", element: <Login />, breadcrumb: "கடவுச்சொல் சரிபார்ப்பு" },
  { path: "/auth/password/verify", element: <PasswordVerify />, breadcrumb: "கடவுச்சொல் சரிபார்ப்பு" },
  { path: "/__/auth/action", element: <SignUpVerify />, breadcrumb: "சரிபார்ப்பு" },
  { path: "/auth/logout", element: <Logout />, breadcrumb: "வெளியேறு" },

  { path: "/user", element: <UserProfileHome />, breadcrumb: "பயனர் விவரம்" },
  { path: "/user/profile", element: <UserProfileHome />, breadcrumb: "பயனர் விவரம்" },
  { path: "/user/inbox", element: <UserInbox />, breadcrumb: "உங்கள் செய்திகள்" },
  { path: "/user/mobile-verification", element: <UserMobileVerification />, breadcrumb: "மொபைல் உறுதிப்படுத்தல்" },
  { path: "/user/validate-session-otp", element: <UserSessionOTPValidation />, breadcrumb: "பயனர் OTP சரிபார்ப்பு" },
  { path: "/user/set-profile-password", element: <UserProfileSetPassword />, breadcrumb: "கடவுச்சொல்லை அமைக்கவும்" },
  //{ path: "/user-address/update", element: <UserAddressUpdate /> },

  { path: "/user/donations", element: <UserDonations />, breadcrumb: "நன்கொடை விவரங்கள்" },
  { path: "/user/family", element: <UserFamily />, breadcrumb: "குடும்ப விவரங்கள்" },

  { path: "/user/family/create", element: <UserFamilyCreate />, breadcrumb: "பயனர் குடும்பம் உருவாக்கு" },
  { path: "/user/family/update/:id", element: <UserFamilyUpdate />, breadcrumb: "பயனர் குடும்பம் மேம்பாடு" },
  { path: "/user/family/view/:id", element: <UserFamilyView />, breadcrumb: "பயனர் குடும்பம் பார்க்க" },
  { path: "/user/family/address-update/:id", element: <UserFamilyAddressUpdate />, breadcrumb: "பயனர் குடும்ப முகவரி மேம்பாடு" },

  { path: "/user/family/missing-info-update", element: <UserFamilyMissingInfoUpdate />, breadcrumb: "பயனர் குடும்ப மேம்பாடு" },

  { path: "/user/family/member-create/:familyId", element: <UserFamilyMemberCreate />, breadcrumb: "பயனர் குடும்ப உறுப்பினர் உருவாக்கு" },
  { path: "/user/family/member-update/:id", element: <UserFamilyMemberUpdate />, breadcrumb: "பயனர் குடும்ப உறுப்பினர் மேம்பாடு" },
  { path: "/user/family/member-view/:id", element: <UserFamilyMemberView />, breadcrumb: "பயனர் குடும்ப உறுப்பினர் பார்க்க" },

  { path: "/event", element: <CalendarEvents />, breadcrumb: "நிகழ்வு நாட்காட்டி" },
  { path: "/event/calendar", element: <CalendarEvents />, breadcrumb: "நிகழ்வு நாட்காட்டி" },
  { path: "/event/admin", element: <AdminCalendar />, breadcrumb: "நிகழ்வு நிர்வாகி" },

  { path: "/address/admin", element: <AddressAdmin />, breadcrumb: "முகவரி நிர்வாகி" },
  { path: "/address-area/create", element: <AddressAreaCreate />, breadcrumb: "முகவரி பகுதி உருவாக்கு" },
  { path: "/address-area/update/:pincode", element: <AddressAreaUpdate />, breadcrumb: "முகவரி பகுதி மேம்பாடு" },
  { path: "/address-sub-area/update/:pincode", element: <AddressSubAreaUpdate />, breadcrumb: "துணை பகுதி மேம்பாடு" },
  { path: "/address-area/view/:pincode", element: <AddressAreaView />, breadcrumb: "முகவரி பகுதி பார்க்க" },

  { path: "/family", element: <FamilyAdmin />, breadcrumb: "குடும்ப நிர்வாகி" },
  { path: "/family/address-update/:id", element: <FamilyAddressUpdate />, breadcrumb: "குடும்ப முகவரி மேம்பாடு" },
  { path: "/family/create", element: <FamilyCreate />, breadcrumb: "குடும்பம் உருவாக்கு" },
  { path: "/family/update/:id", element: <FamilyUpdate />, breadcrumb: "குடும்பம் மேம்பாடு" },
  { path: "/family/view/:id", element: <FamilyView />, breadcrumb: "குடும்பம் பார்க்க" },
  { path: "/family/activate/:id", element: <FamilyActivate />, breadcrumb: "குடும்பம் செயல்படுத்து" },

  { path: "/family/member-create/:familyId", element: <FamilyMemberCreate />, breadcrumb: "குடும்ப உறுப்பினர் உருவாக்கு" },
  { path: "/family/member-activate/:id", element: <FamilyMemberActivate />, breadcrumb: "குடும்ப உறுப்பினர் செயல்படுத்து" },
  { path: "/family/member-bulk-move/:id", element: <BulkMoveFamilyMembers />, breadcrumb: "கூட்டமாக மாற்று" },
  { path: "/family/member-update/:id", element: <FamilyMemberUpdate />, breadcrumb: "குடும்ப உறுப்பினர் மேம்பாடு" },
  { path: "/family/member-view/:id", element: <FamilyMemberView />, breadcrumb: "குடும்ப உறுப்பினர் பார்க்க" },

  { path: "/contactus", element: <ContactUs />, breadcrumb: "தொடர்பு கொள்ள" },
  { path: "/privacy-policy", element: <PrivacyPolicy />, breadcrumb: "தனியுரிமைக் கொள்கை" },
 
  { path: "/books/:id", element: <BookPage />, breadcrumb: "பொன்னச்சியம்மன் வரலாறு" },

  { path: "/qr-code", element: <GenerateQRCode />, breadcrumb: "QR குறியீடு" },

  { path: "/config", element: <CategoryAdmin />, breadcrumb: "கட்டமைப்பு" },
  { path: "/config/category", element: <CategoryAdmin />, breadcrumb: "கட்டமைப்பு நிர்வாகம்" },

  { path: "/donation", element: <DonationAdmin />, breadcrumb: "நன்கொடை நிர்வாகம்" },
  { path: "/donation/create", element: <DonationCreate />, breadcrumb: "புதிய நன்கொடை" },
  { path: "/donation/view/:id", element: <DonationView />, breadcrumb: "நன்கொடைகள் பார்வை" },
  { path: "/donation/create-guest", element: <GuestDonationCreate />, breadcrumb: "புதிய உறம்பரையர் நன்கொடை" },


  { path: "/expense", element: <ExpensesAdmin />, breadcrumb: "செலவுகள் நிர்வாகம்" },
  { path: "/expense/create", element: <ExpenseCreate />, breadcrumb: "புதிய செலவு" },
  { path: "/expense/view", element: <ExpenseView />, breadcrumb: "செலவுகள் பார்வை" },
  { path: "/expense/search", element: <ExpensesSearch />, breadcrumb: "செலவுகள் தேடல்" },

  { path: "/statements", element: <StatementsAdmin />, breadcrumb: "வரவு செலவு அறிக்கைகள்" },


  { path: "/contact", element: <ContactAdmin />, breadcrumb: "தொடர்பு நிர்வாகம்" },
  { path: "/contact/bulk-sms-send", element: <BulkSmsSend />, breadcrumb: "bulk-sms-send" },
  { path: "/contact/bulk-sms-delivery-check", element: <BulkSmsDeliveryCheck />, breadcrumb: "bulk-sms-delivery-check" },
  { path: "/contact/bulk-update-mobile-status", element: <BulkMobileStatusUpdate />, breadcrumb: "bulk-update-mobile-status" },
  { path: "/contact/donation-folloup-sms-send", element: <DonationFollowUpSmsSend />, breadcrumb: "donation-folloup-sms-send" },


  { path: "*", element: <Home /> }, // Catch-all route
];

export default routesConfig;